import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles<{ isExpanded?: boolean; arePricesLoading?: boolean }>()((theme, params = {}) => {
    const isExpanded = params.isExpanded ?? false;
    const arePricesLoading = params.arePricesLoading ?? false;

    return {
        // Desktop styles
        flyingCartCard: {
            position: "sticky",
            top: 96,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            overflow: "hidden",
            minWidth: 306,
            maxWidth: 320,
            width: "100%",
            flex: 1,
            height: "fit-content",
        },
        flyingCartContent: {
            padding: theme.spacing(3),
        },
        flyingCartHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing(3),
        },
        flyingCartTitle: {
            color: theme.palette.primary.main,
            textAlign: "left",
            flex: 1,
        },
        flyingCartEditButton: {
            color: theme.palette.secondary.main,
            marginLeft: theme.spacing(2),
        },

        // Mobile styles
        flyingCartMobileContainer: {
            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
            boxShadow: theme.shadows[2],
            maxHeight: "70vh",
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            height: isExpanded ? "80vh" : "90px",
            minHeight: "80px",
            transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            overflow: isExpanded ? "hidden" : "visible",
        },
        flyingCartMobileOverlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
        },
        flyingCartMobileToggleButton: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: "50%",
            width: 40,
            height: 40,
            position: "fixed",
            marginBottom: "20px",
            bottom: isExpanded ? "67.8vh" : "70px",
            left: "50%",
            transform: "translateX(-50%) translateY(50%)",
            zIndex: 1001,
            transition: "bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
            },
            "&:focus": {
                backgroundColor: theme.palette.primary.main,
            },
        },
        flyingCartMobileArrow: {
            transition: "transform 0.3s ease-in-out",
        },
        flyingCartMobileArrowRotated: {
            transform: "rotate(180deg)",
        },
        flyingCartMobileExpandedContent: {
            overflow: "auto",
            padding: theme.spacing(2),
            height: "calc(80vh - 200px)",
            marginBottom: "100px",
        },
        flyingCartMobileFooter: {
            backgroundColor: theme.palette.primary.main,
            padding: theme.spacing(2),
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(2),
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
        },
        flyingCartMobileFooterInfo: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
        },
        flyingCartMobileFooterTitle: {
            color: theme.palette.secondary.contrastText,
        },
        flyingCartMobileFooterGrid: {
            display: "flex",
            flexDirection: "column",
            rowGap: 0,
            ...(arePricesLoading && {
                alignItems: "center",
            }),
            "& .MuiTypography-root": {
                color: theme.palette.secondary.contrastText,
            },
        },
        flyingCartMobileFooterToday: {
            color: theme.palette.secondary.contrastText,
        },
        flyingCartMobileFooterMonthly: {
            color: theme.palette.secondary.contrastText,
        },
        flyingCartMobilePriceSkeleton: {
            borderRadius: 10,
            display: "inline-block",
            height: 20,
            width: 60,
        },
        flyingCartItems: {
            marginBottom: theme.spacing(2),
        },
        flyingCartDivider: {
            margin: theme.spacing(2, 0),
            backgroundColor: theme.palette.divider,
        },
        orderSummaryCard: {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            overflow: "visible",
            position: "relative",
        },
        orderSummaryToggleButtonContainer: {
            position: "absolute",
            bottom: -20,
            left: 0,
            right: 0,
            zIndex: 1001,
            display: "flex",
            justifyContent: "center",
        },
        orderSummaryToggleButton: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: "50%",
            width: 40,
            height: 40,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
            },
            "&:focus": {
                backgroundColor: theme.palette.primary.main,
            },
        },
        orderSummaryToggleArrow: {
            fontSize: "18px",
            height: "18px",
            transition: "transform 0.3s ease-in-out",
            width: "18px",
        },
        orderSummaryToggleArrowRotated: {
            transform: "rotate(180deg)",
        },
        orderSummaryToggleArrowWithRotation: {
            fontSize: "18px",
            height: "18px",
            transition: "transform 0.3s ease-in-out",
            width: "18px",
            ...(isExpanded && {
                transform: "rotate(180deg)",
            }),
        },
    };
});
